import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonOption } from '../../Fundamentals/Button';
import StandardModalBase, { ModalFooter } from '../../Fundamentals/Modal/StandardModal';

interface StandardModalProps {
    title: string;
    isLoading?: boolean;
    onClose?: () => void;
    children?: ReactNode;
}

const StandardModal = StandardModalBase as unknown as FC<StandardModalProps>;

interface PackageSalesChannelRemoveModalProps {
    channelName: string;
    isRemoving: boolean;
    onRemove: () => void;
    onCancel: () => void;
}

const PackageSalesChannelRemoveModal = ({ channelName, isRemoving, onRemove, onCancel }: PackageSalesChannelRemoveModalProps) => {
    const { t } = useTranslation();

    return (
        <StandardModal title={t('packages.removeSalesChannelTitle') ?? ''} isLoading={isRemoving} onClose={onCancel}>
            <p>{t('packages.removeSalesChannelConfirm', { name: channelName })}</p>
            <ModalFooter>
                <div className="w-100 d-flex justify-content-end gap-8">
                    <Button option={ButtonOption.PRIMARY} onClick={onRemove}>
                        {t('packages.removeSalesChannelLink')}
                    </Button>
                    <Button onClick={onCancel}>{t('common.cancel')}</Button>
                </div>
            </ModalFooter>
        </StandardModal>
    );
};

export default PackageSalesChannelRemoveModal;
